import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";


const getVehicleExpensesCategories = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleExpenses}?isAll=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getVehicleExpensesById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleExpenses}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertVehicleExpenses = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.VehicleExpenses,
    input
  );
  return data;
};

const updateVehicleExpenses = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.VehicleExpenses,
    input
  );
  return data;
};

const deleteVehicleExpenses = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.VehicleExpenses}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useVehicleExpensesCategoriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleExpenses],
    queryFn: () => getVehicleExpensesCategories(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetVehicleExpensesByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleExpenses],
    queryFn: () => getVehicleExpensesById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertVehicleExpensesMutation = () => {
  return useMutation({
    mutationFn: insertVehicleExpenses,
  });
};

export const useUpdateVehicleExpensesMutation = () => {
  return useMutation({
    mutationFn: updateVehicleExpenses,
  });
};

export const useDeleteVehicleExpensesMutation = () => {
  return useMutation({
    mutationFn: deleteVehicleExpenses,
  });
};
